export default [
    {
        path: 'api-accounts',
        name: 'api-accounts',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: 'roles.api_accounts.view',
            translate: (t) => t('menu_points.api_accounts').ucFirst()
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'api-accounts-list'},
        children: [
            {
                path: '',
                name: 'api-accounts-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: 'roles.api_accounts.view',
                    translate: (t) => t('menu_points.api_accounts').ucFirst()
                },
                component: () => import('@/views/pages/system/accounts/list.vue')
            },
            {
                path: 'create',
                name: 'api-account-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: 'roles.api_accounts.create',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('system::accounts.account', 1)}).ucFirst()

                },
                component: () => import('@/views/pages/system/accounts/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'api-account-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: 'roles.api_accounts.update',
                    translate: (t, tc) => t('base.edit_item', {item: tc('system::accounts.account', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/accounts/item.vue')
            },
        ]
    },
    {
        path: 'users',
        name: 'users',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: 'roles.users.view',
            translate: (t) => {
                return t('menu_points.users').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'users-list'},
        children: [
            {
                path: '',
                name: 'users-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: 'roles.users.view',
                    translate: (t) => {
                        return t('menu_points.users').ucFirst();
                    },
                },
                component: () => import('@/views/pages/system/users/list.vue'),
            },
            {
                path: 'create',
                name: 'user-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: 'roles.users.create',
                    translate: (t, tc) => t('base.create_new_item', {item: tc('users.user', 1)}).ucFirst()

                },
                component: () => import('@/views/pages/system/users/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'user-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: 'roles.users.update',
                    available_for_superior: true,
                    translate: (t, tc) => t('base.edit_item', {item: tc('users.user', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/system/users/item.vue')
            },
            {
                path: 'profile',
                name: 'users-profile',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: 'roles.users.view',
                    translate: (t) => t('menu_points.profile').ucFirst()
                },
                component: () => import('@/views/pages/system/users/profile-edit.vue')
            },
            {
                path: 'profiles',
                name: 'user-public-profiles',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => t('menu_points.profiles').ucFirst()
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'profiles-list'},
                children: [
                    {
                        path: '',
                        name: 'profiles-list',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => t('menu_points.profiles').ucFirst()
                        },
                        component: () => import('@/views/pages/system/users/public-profile.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'user-public-profile',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => t('menu_points.profile').ucFirst()
                        },
                        component: () => import('@/views/pages/system/users/public-profile.vue')
                    },
                ]
            },
            {
                path: 'microsoft-graph',
                name: 'users-microsoft-graph',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'modules.crm',
                    translate: () => { return 'Microsoft Graph'; }

                },
                component: () => import('@/views/pages/system/users/microsoft.vue'),
            },
            {
                path: 'google-api',
                name: 'users-google-api',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: 'modules.crm',
                    translate: () => { return 'Google API'; }

                },
                component: () => import('@/views/pages/system/users/google.vue'),
            },
        ]
    },
    {
        path: 'menu-system',
        name: 'menu-system',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.menus.view'],
            translate: (t) => t('menu_points.menu_system').ucFirst()
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'menus-list'},
        children: [
            {
                path: 'menus',
                name: 'menus',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.menus.view'],
                    translate: (t) => t('menu_points.menus').ucFirst()
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'menus-list'},
                children: [
                    {
                        path: '',
                        name: 'menus-list',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: ['roles.menus.view'],
                            translate: (t) => t('menu_points.menus').ucFirst()
                        },
                        component: () => import('@/views/pages/system/menus/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'menu-create',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: ['roles.menus.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('menus::menus.menu', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/system/menus/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'menu-edit',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: ['roles.menus.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('menus::menus.menu', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/system/menus/item.vue')
                    },
                ]
            },
            {
                path: 'menu-point-categories',
                name: 'menu-point-categories',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.menu_point_categories.view'],
                    translate: (t) => t('menu_points.menu_point_categories').ucFirst()
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'menu-point-categories-list'},
                children: [
                    {
                        path: '',
                        name: 'menu-point-categories-list',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: ['roles.menu_point_categories.view'],
                            translate: (t) => t('menu_points.menu_point_categories').ucFirst()
                        },
                        component: () => import('@/views/pages/system/menu-point-categories/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'menu-point-category-create',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: ['roles.menu_point_categories.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('menus::menu_point_categories.menu_point_category', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/system/menu-point-categories/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'menu-point-category-edit',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: ['roles.menu_point_categories.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('menus::menu_point_categories.menu_point_category', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/system/menu-point-categories/item.vue')
                    },
                ]
            },
            {
                path: 'menu-points',
                name: 'menu-points',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.menu_points.view'],
                    translate: (t) => t('menu_points.menu_points').ucFirst()
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'menu-points-list'},
                children: [
                    {
                        path: '',
                        name: 'menu-points-list',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: ['roles.menu_points.view'],
                            translate: (t) => t('menu_points.menu_points').ucFirst()
                        },
                        component: () => import('@/views/pages/system/menu-points/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'menu-point-create',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: ['roles.menu_points.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('menus::menu_points.menu_point', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/system/menu-points/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'menu-point-edit',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: ['roles.menu_points.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('menus::menu_points.menu_point', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/system/menu-points/item.vue')
                    },
                ]
            },
        ]
    },

    {
        path: 'authorization',
        name: 'authorization',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: 'menu_points./system/authorization',
            translate: (t) => t('menu_points.authorization').ucFirst()
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        children: [
            {
                path: 'structure',
                name: 'authorization-structure',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: 'menu_points./system/authorization/structure',
                    translate: (t) => t('menu_points.structure').ucFirst()
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                children: [
                    {
                        path: 'permissions',
                        name: 'roles',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: 'roles.roles.view',
                            translate: (t) => t('menu_points.permissions').ucFirst()
                        },
                        component: () => import('@/views/helpers/grouper/grouper.vue'),
                        redirect: { name: 'roles-list'},
                        children: [
                            {
                                path: '',
                                name: 'roles-list',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.roles.view',
                                    translate: (t) => t('menu_points.permissions').ucFirst()
                                },
                                component: () => import('@/views/pages/system/roles/list.vue')
                            },
                            {
                                path: 'create',
                                name: 'role-create',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.roles.create',
                                    translate: (t, tc) => t('base.create_new_item', {item: tc('authorization::roles.role', 1)}).ucFirst()
                                },
                                component: () => import('@/views/pages/system/roles/item.vue')
                            },
                            {
                                path: ':id(\\d+)',
                                name: 'role-edit',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.roles.update',
                                    translate: (t, tc) => t('base.edit_item', {item: tc('authorization::roles.role', 1)}).ucFirst()
                                },
                                component: () => import('@/views/pages/system/roles/item.vue')
                            },
                        ]
                    },
                    {
                        path: 'role-groups',
                        name: 'role-groups',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: 'roles.role_groups.view',
                            translate: (t) => t('menu_points.role_groups').ucFirst()
                        },
                        component: () => import('@/views/helpers/grouper/grouper.vue'),
                        redirect: { name: 'role-groups-list'},
                        children: [
                            {
                                path: '',
                                name: 'role-groups-list',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.role_groups.view',
                                    translate: (t) => t('menu_points.role_groups').ucFirst()
                                },
                                component: () => import('@/views/pages/system/role-groups/list.vue')
                            },
                            {
                                path: 'create',
                                name: 'role-group-create',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.role_groups.create',
                                    translate: (t, tc) => t('base.create_new_item', {item: tc('authorization::role_groups.role_group', 1)}).ucFirst()
                                },
                                component: () => import('@/views/pages/system/role-groups/item.vue')
                            },
                            {
                                path: ':id(\\d+)',
                                name: 'role-group-edit',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.role_groups.update',
                                    translate: (t, tc) => t('base.edit_item', {item: tc('authorization::role_groups.role_group', 1)}).ucFirst()
                                },
                                component: () => import('@/views/pages/system/role-groups/item.vue')
                            },
                        ]
                    },
                    {
                        path: 'role-categories',
                        name: 'role-categories',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: 'roles.role_categories.view',
                            translate: (t) => t('menu_points.role_categories').ucFirst()
                        },
                        component: () => import('@/views/helpers/grouper/grouper.vue'),
                        redirect: { name: 'role-categories-list'},
                        children: [
                            {
                                path: '',
                                name: 'role-categories-list',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.role_categories.view',
                                    translate: (t) => t('menu_points.role_categories').ucFirst()
                                },
                                component: () => import('@/views/pages/system/role-categories/list.vue')
                            },
                            {
                                path: 'create',
                                name: 'role-category-create',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.role_categories.create',
                                    translate: (t, tc) => t('base.create_new_item', {item: tc('authorization::role_categories.role_category', 1)}).ucFirst()
                                },
                                component: () => import('@/views/pages/system/role-categories/item.vue')
                            },
                            {
                                path: ':id(\\d+)',
                                name: 'role-category-edit',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.role_categories.update',
                                    translate: (t, tc) => t('base.edit_item', {item: tc('authorization::role_categories.role_category', 1)}).ucFirst()
                                },
                                component: () => import('@/views/pages/system/role-categories/item.vue')
                            },
                        ]
                    },
                    {
                        path: 'modules',
                        name: 'modules',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: 'roles.modules.view',
                            translate: (t) => t('menu_points.modules').ucFirst()
                        },
                        component: () => import('@/views/helpers/grouper/grouper.vue'),
                        redirect: { name: 'modules-list'},
                        children: [
                            {
                                path: '',
                                name: 'modules-list',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.modules.view',
                                    translate: (t) => t('menu_points.modules').ucFirst()
                                },
                                component: () => import('@/views/pages/system/modules/list.vue')
                            },
                            {
                                path: 'create',
                                name: 'module-create',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.modules.create',
                                    translate: (t, tc) => t('base.create_new_item', {item: tc('authorization::modules.module', 1)}).ucFirst()
                                },
                                component: () => import('@/views/pages/system/modules/item.vue')
                            },
                            {
                                path: ':id(\\d+)',
                                name: 'module-edit',
                                meta: {
                                    modules: [],
                                    authentication_required: true,
                                    authorization_required: 'roles.modules.update',
                                    translate: (t, tc) => t('base.edit_item', {item: tc('authorization::modules.module', 1)}).ucFirst()
                                },
                                component: () => import('@/views/pages/system/modules/item.vue')
                            },
                        ]
                    },
                ]
            },
            {
                path: 'permission-management',
                name: 'permission-management',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: 'menu_points./system/authorization/permission-management',
                    translate: (t) => t('menu_points.permission_management').ucFirst()
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                children: [
                    {
                        path: 'individuals',
                        name: 'auth-individuals',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: 'menu_points./system/authorization/permission-management/individuals',
                            translate: (t) =>
                                t('menu_points.individuals').ucFirst(),
                        },
                        component: () => import('@/views/pages/system/permissions/individual.vue')
                    },
                    {
                        path: 'role-groups',
                        name: 'auth-role-groups',
                        meta: {
                            modules: [],
                            authentication_required: true,
                            authorization_required: 'menu_points./system/authorization/permission-management/role-groups',
                            translate: (t) =>
                                t('menu_points.role_group_management').ucFirst(),
                        },
                        component: () => import('@/views/pages/system/permissions/role-group.vue'),
                    },
                ]
            },
        ]
    },
    {
        path: 'install-services',
        name: 'system-install-services',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: 'is_developer',
            translate: (t) => {
                return t('menu_points.install_services').ucFirst();
            },
        },
        component: () => import('@/views/pages/system/install-services.vue')
    },
    {
        path: 'resource-monitor',
        name: 'system-resource-monitor',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.resource_monitor').ucFirst();
            },
        },
        component: () => import('@/views/pages/system/resource-monitor.vue')
    },
    {
        path: '/files/:path*',
        name: 'file',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.files').ucFirst();
            },
        },
        component: () => import('@/views/pages/system/files/item.vue')
    },
]